var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _polygon, _path31, _polygon2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _polygon3, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon4, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _polygon5, _path65, _polygon6, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _polygon7, _path79, _polygon8, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 333.56 333.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#543757;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_50);}.cls-3{fill:#0f9ef1;}.cls-4{fill:#70ccea;}.cls-5{fill:#119cff;}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_8);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_8-2);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_8-3);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_8-4);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_8-5);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_8-6);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_27);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_46);}.cls-14{fill:#f4f4f4;}.cls-15{fill:#2fc314;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50",
    cx: 166.78,
    cy: 166.78,
    r: 166.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#42285b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774b57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8",
    x1: 500.78,
    y1: 290.42,
    x2: 534.01,
    y2: 290.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38c531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fc701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-2",
    x1: 500.37,
    y1: 290.43,
    x2: 534.13,
    y2: 290.43,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-3",
    x1: 328.12,
    y1: 314.92,
    x2: 530.52,
    y2: 314.92,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-4",
    x1: 328.01,
    y1: 314.97,
    x2: 530.74,
    y2: 314.97,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-5",
    x1: 314.6,
    y1: 300.12,
    x2: 391.71,
    y2: 300.12,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-6",
    x1: 314.49,
    y1: 300.08,
    x2: 392.43,
    y2: 300.08,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_27",
    x1: 381.17,
    y1: 260.39,
    x2: 513.09,
    y2: 260.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54b25a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#56b358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93cf29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_46",
    x1: 380.05,
    y1: 279.8,
    x2: 511.69,
    y2: 279.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4e7354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4e7553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4f7952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#52864e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#579b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#589f46"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ECO green project ia vectorisation rond") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 166.78,
    cy: 146.95,
    r: 123.24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 166.78,
    cy: 166.78,
    r: 166.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M350,239.29V219.18s9.84-17.62,11.31-17.61c-.13,3.89,0,16.4,0,16.4S350,233.1,350,239.29Z",
    transform: "translate(-256.27 -126.66)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M350.11,239.29h-.22V219.13c1-1.81,9.92-17.68,11.41-17.67h.11v.11c-.13,3.85,0,16.28,0,16.4v0l0,0C361.29,218.19,350.11,233.21,350.11,239.29Zm0-20.08v18.35c1.53-6.7,10.44-18.75,11.09-19.62,0-.75-.11-12.33,0-16.23C359.89,202.34,353.94,212.38,350.12,219.21Z",
    transform: "translate(-256.27 -126.66)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M350.32,244.72s8-20.23,11.5-20.74c-.13,4.47,1.72,17,1.72,17s-10.55,13.73-9.91,16.6A118.1,118.1,0,0,1,350.32,244.72Z",
    transform: "translate(-256.27 -126.66)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.53,257.65a118.86,118.86,0,0,1-3.32-12.91v-.06c.33-.83,8.06-20.3,11.59-20.81l.13,0V224c-.13,4.41,1.7,16.9,1.71,17v.05l0,0c-.1.14-10.5,13.72-9.88,16.51Zm-3.1-12.92a117.56,117.56,0,0,0,3.1,12.21c.65-3.82,9.21-15.06,9.89-15.95-.12-.83-1.8-12.47-1.71-16.88C358.29,225.06,350.77,243.87,350.43,244.73Z",
    transform: "translate(-256.27 -126.66)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355,263s7.8-16.46,9.58-16.4c.9,4.15,5.74,18.46,5.74,18.46s-6.71,8-6.45,12.19C360.33,273.14,355.29,264.77,355,263Z",
    transform: "translate(-256.27 -126.66)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364,277.55l-.22-.25c-3.45-4-8.56-12.45-8.89-14.3v0l0,0c.8-1.69,7.85-16.47,9.68-16.47h.09l0,.09c.88,4.09,5.69,18.3,5.74,18.44l0,.06,0,.05c-.07.08-6.68,8-6.43,12.11ZM355.08,263c.38,1.85,5.23,9.85,8.64,13.92.06-4.14,5.86-11.2,6.45-11.91-.34-1-4.8-14.22-5.7-18.31C363.09,247.05,358.14,256.54,355.08,263Z",
    transform: "translate(-256.27 -126.66)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.73,266.51v14.61S341.17,258,344.1,248.07A168.54,168.54,0,0,0,351.73,266.51Z",
    transform: "translate(-256.27 -126.66)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.84,281.63l-.21-.46c-.11-.24-10.54-23.32-7.64-33.14l.1-.33.11.33a170.79,170.79,0,0,0,7.63,18.43v15.17Zm-7.73-33.19c-2.34,9.12,6.05,28.86,7.51,32.16V266.53A172.41,172.41,0,0,1,344.11,248.44Z",
    transform: "translate(-256.27 -126.66)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.9,282.83s.23-11.11.56-11.37c1.73,1.92,8.52,11,9.48,11.16-.26,2.73,2.43,16.72,3.76,18.64C362.79,297.09,353.42,285.75,352.9,282.83Z",
    transform: "translate(-256.27 -126.66)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.62,301.33c-3.78-4-13.3-15.49-13.83-18.48h0c.07-3.36.27-11.19.6-11.45l.08-.07.07.08c.59.65,1.72,2.08,3,3.73,2.44,3.07,5.78,7.27,6.38,7.39l.1,0v.1c-.25,2.6,2.39,16.62,3.74,18.57ZM353,282.82c.52,2.84,9.2,13.37,13.24,17.8-1.4-3.44-3.6-15.34-3.42-17.93-.77-.37-3.26-3.46-6.42-7.43-1.23-1.55-2.31-2.9-2.92-3.59C353.29,272.63,353.1,278.73,353,282.82Z",
    transform: "translate(-256.27 -126.66)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.31,209.78s17-11,18.67-10.54c.61-6.12,3.83-19.27,3.83-19.27s-17.75,8.09-20.35,11.46C370.54,196,369.31,209.78,369.31,209.78Z",
    transform: "translate(-256.27 -126.66)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.18,210l0-.23c0-.14,1.24-13.82,2.15-18.36v0C374,188,391,180.2,391.76,179.87l.21-.1-.05.22c0,.13-3.23,13.22-3.84,19.26v.13l-.12,0c-1.35-.36-13.87,7.48-18.58,10.53Zm2.38-18.53c-.84,4.24-2,16.29-2.12,18.1,1.92-1.25,16.26-10.46,18.43-10.46h0c.59-5.66,3.35-17.21,3.77-19C389.66,181.08,374,188.35,371.56,191.47Z",
    transform: "translate(-256.27 -126.66)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.08,216.2s17.29-12.07,19.43-10.54c-.15,7.49,0,21.87,0,21.87s-17.28,5.35-19,9.47C368.84,230,368.08,216.2,368.08,216.2Z",
    transform: "translate(-256.27 -126.66)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.39,237.63l0-.63c.31-6.95-.44-20.65-.45-20.79v-.06l0,0c.71-.49,17.38-12.1,19.56-10.54l0,0v.06c-.15,7.41,0,21.73,0,21.87v.08l-.07,0c-.18.05-17.26,5.37-18.91,9.41Zm-.19-21.37c.05,1,.71,13.42.46,20.26,2.54-3.94,17.36-8.64,18.73-9.07,0-1.18-.13-14.6,0-21.73C385.53,204.68,373,212.92,368.2,216.26Z",
    transform: "translate(-256.27 -126.66)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.3,241.9s15.91-10.39,18.2-7.49c-.16,5.82,1.52,20.5,1.52,20.5s-16.06,5.29-15.76,7C372,253.37,369.3,241.9,369.3,241.9Z",
    transform: "translate(-256.27 -126.66)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M373.15,261.93v0c-1.21-8.43-3.93-19.87-4-20l0-.08.06,0c.66-.43,16-10.42,18.36-7.46l0,0v0c-.15,5.73,1.5,20.33,1.52,20.48V255l-.09,0c-6.39,2.11-15.8,5.66-15.68,6.86v0Zm-3.73-20c.24,1,2.71,11.51,3.89,19.54,1.56-2,13.73-6,15.59-6.66-.14-1.23-1.65-14.83-1.51-20.38C385.17,231.85,370.53,241.23,369.42,242Z",
    transform: "translate(-256.27 -126.66)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.75,176.91s21.42-3.35,24.17-1.21c0,6.73-.78,21.72-.78,21.72S405,194,396.3,196.93C396.87,192,401.75,176.91,401.75,176.91Z",
    transform: "translate(-256.27 -126.66)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M425.25,197.55l-.13,0c-.2,0-20.2-3.39-28.78-.5l-.17.06,0-.18c.57-4.93,5.41-19.88,5.46-20l0-.07h.06c.88-.13,21.5-3.33,24.26-1.19l0,0v0c0,6.66-.77,21.57-.78,21.72Zm-18.88-1.91A131.47,131.47,0,0,1,425,197.29c.07-1.45.76-15.18.77-21.53-2.78-2-22.66,1.05-24,1.25-.35,1.07-4.78,14.86-5.41,19.76A34.56,34.56,0,0,1,406.37,195.64Z",
    transform: "translate(-256.27 -126.66)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.49,203.94c2.6-1,23.49-3.1,29.07.24.28,1.64-4.09,23.46-4.48,23.74s-19-3.57-26.13-1.08C393.07,221,394.49,203.94,394.49,203.94Z",
    transform: "translate(-256.27 -126.66)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M419,228.05c-.31,0-1-.11-2.84-.37-5.75-.86-17.71-2.63-23.12-.74l-.15.05v-.16c.12-5.76,1.53-22.73,1.54-22.9v-.07l.06,0c1.25-.46,7-1.25,13.45-1.5,4.5-.17,12.51-.17,15.72,1.75l0,0v0c.14.86-.93,7-2,12.42,0,.11-2.18,11.17-2.54,11.43A.35.35,0,0,1,419,228.05Zm-19.06-2.17a120,120,0,0,1,16.25,1.58c1.47.22,2.65.39,2.87.37.47-.93,4.65-21.58,4.45-23.59-5.59-3.26-26.2-1.11-28.87-.22-.09,1.2-1.39,17-1.52,22.66A23.07,23.07,0,0,1,399.89,225.88Z",
    transform: "translate(-256.27 -126.66)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.55,233.06s20.92.23,23.81,2.33c-1.25,4.74-8.12,21.42-8.12,21.42s-14.06-2.83-15.3-2C392.66,251.55,392.55,233.06,392.55,233.06Z",
    transform: "translate(-256.27 -126.66)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.31,256.94l-.09,0c-3.9-.79-14.23-2.68-15.22-2l-.15.1,0-.19c-.28-3.24-.39-21.59-.39-21.77v-.12h.12c.85,0,21,.26,23.86,2.35l.06,0,0,.07c-1.23,4.71-8,21.28-8.11,21.44ZM394,254.56c3.46,0,13,1.9,14.15,2.13.52-1.28,6.82-16.65,8.05-21.26-2.93-1.93-21.92-2.24-23.57-2.26,0,1.52.12,18,.38,21.49A3.48,3.48,0,0,1,394,254.56Z",
    transform: "translate(-256.27 -126.66)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M434.77,176.67s23.94,6.78,27.88,12.11c-.35,5.73-1,18.74-1.65,19.65-2-1-26.32-10.42-28.62-10.3C433,193.54,434.77,176.67,434.77,176.67Z",
    transform: "translate(-256.27 -126.66)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M461,208.57l-.08,0c-2.22-1-26.05-10.29-28.52-10.29h-.18l0-.13c.65-4.54,2.38-21.29,2.4-21.46v-.13l.12,0c1,.28,24,6.85,27.94,12.16l0,0v0c-.05.82-.1,1.78-.16,2.84-.5,8.46-1,16.12-1.51,16.86ZM432.51,198c2.95.17,25.88,9.1,28.44,10.25.53-1.2,1.09-10.84,1.43-16.66.06-1,.11-2,.16-2.8-3.8-5-25.79-11.47-27.67-12C434.71,178.38,433.13,193.53,432.51,198Z",
    transform: "translate(-256.27 -126.66)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.94,206.07s25.89,9.6,27.49,11.55c-1,4-6.77,21.12-9.2,22-3.64-1.61-20.68-9.3-25.11-10.29C425.6,225.67,431.29,207.67,430.94,206.07Z",
    transform: "translate(-256.27 -126.66)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M449.23,239.76h-.05l-1.51-.67c-5.36-2.39-19.61-8.72-23.57-9.62l-.13,0,0-.12c1.64-4.08,7.14-21.71,6.82-23.22l0-.19.19.07c1.06.39,25.93,9.63,27.54,11.58l0,0v.06c-1,4-6.76,21.16-9.27,22.1Zm-25-10.48c4.15,1,18.18,7.23,23.49,9.59l1.47.66c2.36-1.05,8-17.55,9.08-21.88-1.8-1.91-25.06-10.6-27.24-11.42C431.08,208.71,425.82,225.33,424.27,229.28Z",
    transform: "translate(-256.27 -126.66)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.05,257.71s9.86-19.77,9.64-20.38c4.25,1.7,21.51,9.16,21.77,10.21-1.61,1.25-14.19,14.39-21.35,14.9C419.73,261.27,412.57,258.36,412.05,257.71Z",
    transform: "translate(-256.27 -126.66)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M422.09,262.56l0,0c-.83-.41-2.27-1-3.8-1.71-3.48-1.53-6-2.64-6.29-3.05l-.05,0,0-.07c3.89-7.81,9.67-19.67,9.63-20.3l-.09-.23.23.1c3.62,1.44,21.54,9.12,21.83,10.28l0,.07-.05,0c-.27.21-.86.76-1.67,1.53-4.11,3.88-13.75,13-19.74,13.4Zm-9.9-4.87a51.92,51.92,0,0,0,6.16,2.94c1.51.66,2.94,1.29,3.78,1.7,5.92-.45,15.49-9.48,19.58-13.34.75-.71,1.31-1.24,1.61-1.49-.8-1.1-16.31-7.92-21.55-10C421.27,239.42,413.83,254.39,412.19,257.69Z",
    transform: "translate(-256.27 -126.66)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355,283.05V276.9l5.7,6.15s.7,10.12,1.47,10.28S356,285.93,355,283.05Z",
    transform: "translate(-256.27 -126.66)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.16,293.44h-.05c-.15,0-.29-.32-.42-.79-.41-.57-1.09-1.42-1.75-2.26-1.88-2.37-4.46-5.62-5.08-7.3v-6.47l5.92,6.39v0a75.88,75.88,0,0,0,1.09,9.45c.39.55.49.77.42.87A.14.14,0,0,1,362.16,293.44ZM355.07,283c.62,1.65,3.18,4.87,5,7.22.64.81,1.11,1.4,1.45,1.85a85.7,85.7,0,0,1-1-9l-5.48-5.92Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "93.57 145.41 94.03 142.22 91.86 137.93 93.57 145.41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.87,272.68l-2-8.94,2.59,5.12Zm-1.42-7.23,1.37,6,.37-2.57Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "95.47 116.77 103.32 103.39 105.03 113.51 97.63 124.63 95.47 116.77"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M353.86,251.56l-2.23-8.14,0,0,8-13.65,1.77,10.46,0,0Zm-2-8.11L354,251l7.24-10.88-1.65-9.78Z",
    transform: "translate(-256.27 -126.66)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.4,263.36s4.78-13.15,6.13-12.06A112.19,112.19,0,0,0,367.6,264c.23.15-5,9.41-5,9.41C361.13,270.45,357.4,263.36,357.4,263.36Z",
    transform: "translate(-256.27 -126.66)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.62,273.64l-.09-.19c-1.48-2.92-5.19-10-5.23-10l0,0,0-.05c.17-.48,4.28-11.72,5.93-12.18a.43.43,0,0,1,.37.07l0,0v0a118.28,118.28,0,0,0,4,12.63c.11.07.22.14-2.37,4.9-1.26,2.31-2.57,4.62-2.58,4.65Zm-5.1-10.29c.31.59,3.64,6.92,5.11,9.82,2-3.5,4.79-8.65,4.86-9.14a116,116,0,0,1-4.06-12.66.14.14,0,0,0-.14,0C362,251.71,358.71,260.09,357.52,263.35Zm10,.69a.05.05,0,0,0,0,0Z",
    transform: "translate(-256.27 -126.66)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371.05,207l16.11-8.87,1.89-15.87s-15.74,8.47-15.82,8.86S371.05,207,371.05,207Z",
    transform: "translate(-256.27 -126.66)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.91,207.22l0-.22c.08-.63,2.11-15.49,2.19-15.88s11.13-6.38,15.87-8.94l.19-.1-1.92,16.14Zm2.43-16c-.11.67-1.9,13.78-2.15,15.64l15.87-8.73,1.86-15.61C382.8,185.78,373.77,190.72,373.34,191.18Z",
    transform: "translate(-256.27 -126.66)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385.83,226.72l.47-18.84s-15,6.15-16.5,9.88V233S384.5,226.41,385.83,226.72Z",
    transform: "translate(-256.27 -126.66)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369.68,233.22v-15.5c1.47-3.73,15.95-9.69,16.57-9.94l.16-.06-.49,19.14-.13,0c-1.05-.24-11.88,4.48-16,6.32Zm.23-15.44v15.09c1.62-.72,14-6.25,15.82-6.27l.47-18.55C384.59,208.71,371.3,214.34,369.91,217.78Z",
    transform: "translate(-256.27 -126.66)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371.58,242.9s2.79,14.83,3.26,14.73,10-4.92,11.83-4c-.47-5.22-1.78-16.64-1.78-16.64S371.89,240.56,371.58,242.9Z",
    transform: "translate(-256.27 -126.66)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M374.83,257.74l-.08,0c-.54-.36-2.83-12.39-3.28-14.8v0c.31-2.38,12.85-5.83,13.39-6l.12,0,0,.13c0,.11,1.32,11.48,1.78,16.64l0,.19-.18-.09c-1.44-.72-7.77,2.19-10.48,3.44-.81.37-1.18.54-1.28.56Zm-3.14-14.84c1.05,5.58,2.74,14,3.17,14.61.16-.06.64-.28,1.19-.53,4.34-2,8.94-4,10.49-3.5-.44-4.93-1.6-15.07-1.75-16.33C380.3,238.39,372,241.12,371.69,242.9Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "142.72 68 166.61 67.62 167.88 50.42 146.39 51.73 142.72 68"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M398.86,194.77l3.71-16.48,21.7-1.33v.13L423,194.39Zm3.89-16.27-3.62,16.05,23.66-.38,1.24-17Z",
    transform: "translate(-256.27 -126.66)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.86,224l1.44-19.29s24.56-1.14,25.73.84c-.78,3.92-3.83,20.57-3.83,20.57S395.63,222.82,394.86,224Z",
    transform: "translate(-256.27 -126.66)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M418.29,226.23h-.1c-9.05-1.32-22.7-3-23.24-2.17l-.24.35,1.49-19.81h.09c1-.05,24.64-1.12,25.83.9l0,0v0c-.77,3.87-3.79,20.4-3.82,20.57Zm-21.64-2.58c5.16,0,19.17,2,21.46,2.34.26-1.42,3.05-16.64,3.8-20.42-1.16-1.54-18.67-1.08-25.51-.77l-1.42,19A5.91,5.91,0,0,1,396.65,223.65Z",
    transform: "translate(-256.27 -126.66)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.92,235.13s18.16.79,19.76,2.2c-.93,3.33-6.85,17.8-6.85,17.8l-12.61-1.71Z",
    transform: "translate(-256.27 -126.66)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M406.9,255.26l-.09,0-12.7-1.73L393.8,235h.12c.74,0,18.23.81,19.84,2.23l.05,0,0,.07c-.93,3.3-6.8,17.67-6.86,17.82Zm-12.57-1.94L406.76,255c.47-1.15,5.85-14.36,6.8-17.64-1.79-1.28-18-2.06-19.53-2.13Z",
    transform: "translate(-256.27 -126.66)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M434.09,197l2.43-18.21s21.41,7.78,23.65,11c0,3.66-1.25,15.78-1.25,15.78s-23.11-8.85-24.83-8.14",
    transform: "translate(-256.27 -126.66)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M459,205.71l-.13-.05c-8-3-23.42-8.68-24.74-8.14l-.09-.2c1.68-.7,22.7,7.29,24.77,8.09.14-1.37,1.23-12.15,1.24-15.59-2.2-3-21.67-10.22-23.45-10.87L434.2,197l-.22,0,2.44-18.35.13,0c.88.31,21.48,7.82,23.71,11l0,0v0c0,3.63-1.24,15.67-1.25,15.79Z",
    transform: "translate(-256.27 -126.66)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M425.89,227.94l6.88-19s23.18,8.37,23.34,9.52c-1,3.1-7.25,18-8,18.27S426.5,228,425.89,227.94Z",
    transform: "translate(-256.27 -126.66)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M448.06,236.82c-.76,0-6.67-2.42-14.88-5.82-3.62-1.5-7.05-2.92-7.3-2.95h-.13l0-.14,6.91-19.12.1,0c.06,0,5.87,2.12,11.62,4.34,11.69,4.49,11.77,5.06,11.8,5.28v0c-.84,2.57-7.19,18.06-8.09,18.33Zm-22-8.95c.62.19,3.13,1.23,7.22,2.92,5.68,2.35,14.24,5.91,14.8,5.81.71-.31,6.73-14.51,7.93-18.16-.38-.88-14-6.06-23.16-9.38Z",
    transform: "translate(-256.27 -126.66)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422,260.51l-7.31-3.7L423,239.63l17.43,7.72S429.32,259.58,422,260.51Z",
    transform: "translate(-256.27 -126.66)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422,260.63l-7.44-3.77L423,239.49l17.67,7.82-.11.12c-.11.12-11.24,12.27-18.52,13.19Zm-7.15-3.86L422,260.4c6.82-.9,17.1-11.78,18.25-13l-17.2-7.61Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "94.91 103.39 103.12 90.85 104.04 78.12 94.53 93.05 94.91 103.39"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.08,230.4l-.39-10.72,0,0,9.75-15.29-.95,13.19,0,0Zm-.17-10.66.37,10,8-12.23.89-12.26Z",
    transform: "translate(-256.27 -126.66)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M506,297.83s13.28-24.5,27.22-27.64c.22,5.4,8.52,36.2-32.4,40.46,11.25-7.87,24.07-20.23,25-26.52C519.46,287.27,509.56,294.91,506,297.83Z",
    transform: "translate(-256.27 -126.66)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500.37,310.8l.35-.24c11.17-7.81,23.75-20,24.89-26.24-6,3-15.4,10.2-19.58,13.6l-.43.35.26-.49a105.68,105.68,0,0,1,8.39-12.66c4.63-6,11.67-13.41,18.9-15l.13,0v.14c0,.51.11,1.25.23,2.19.7,5.49,2.16,16.92-5.08,26.05-5.42,6.83-14.72,11-27.65,12.33Zm25.52-26.86,0,.2c-.89,6.19-13.42,18.42-24.67,26.35,12.64-1.38,21.75-5.48,27.08-12.2,7.17-9.05,5.73-20.42,5-25.88-.11-.87-.19-1.57-.22-2.08-12.59,3-24.77,23.58-26.75,27.06,4.44-3.56,13.59-10.47,19.37-13.36Z",
    transform: "translate(-256.27 -126.66)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M328.12,264.58s17.15,81.56,95.36,87.76c0,0,62,.52,82.41-24.1-6.16,2-28.32,4.18-32.51,5.16,12.32-10.83,24.39-18.46,57.14-15.24-11.58,13.54-47.66,51.2-106.46,46.74S331.54,319,328.12,264.58Z",
    transform: "translate(-256.27 -126.66)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M433.58,365.37c-3.11,0-6.28-.12-9.53-.36a112.88,112.88,0,0,1-39.36-9.92,93,93,0,0,1-29.45-21.55c-16.09-17.59-25.5-41.43-27.23-69l.21,0a134.61,134.61,0,0,0,18.35,41.52c12.81,19.29,36.57,42.95,76.92,46.15A222.67,222.67,0,0,0,457,349.41c16.32-2.66,37.93-8.46,48.57-21-4.07,1.19-13.71,2.46-21.51,3.48-4.87.64-9.07,1.2-10.66,1.57l-.42.1.33-.29c6.55-5.76,12.62-10.16,20.94-12.91,9.43-3.12,21-3.87,36.28-2.36l.21,0-.14.16C515.13,336.32,482.61,365.4,433.58,365.37ZM328.32,265.9c4.1,56.87,40.68,94.71,95.75,98.89,54.12,4.11,89.74-27.32,106.23-46.54-32.67-3.17-44.59,4.51-56.53,14.95,1.84-.37,5.77-.88,10.27-1.48,8-1.05,18-2.36,21.82-3.58l.35-.11-.24.29c-4.67,5.62-11.92,10.4-21.55,14.18A135.16,135.16,0,0,1,457,349.63a223.1,223.1,0,0,1-33.55,2.82c-17.87-1.42-34-6.91-48-16.34a107.49,107.49,0,0,1-29.14-29.91A136.84,136.84,0,0,1,328.32,265.9Z",
    transform: "translate(-256.27 -126.66)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M328.14,222.8s-15.5,56.84,2.68,94.28,60.89,60.36,60.89,60.36-45.42-9.34-67.07-53.08S322.22,228.26,328.14,222.8Z",
    transform: "translate(-256.27 -126.66)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392.43,377.7l-.74-.15a100.81,100.81,0,0,1-25.45-10.15,105.94,105.94,0,0,1-22.06-16.22,96.58,96.58,0,0,1-19.64-26.77c-11.6-23.45-11.08-48.4-8.6-65.2a127.33,127.33,0,0,1,6-24.42c2.14-5.94,4.48-10.56,6.11-12.07l.28-.26-.1.37a207.06,207.06,0,0,0-5.47,33.08c-1.46,17.22-1.23,41.8,8.15,61.12s25.43,34.69,37.24,44.18a174.48,174.48,0,0,0,23.6,16.14ZM327.92,223.18c-2.9,3.22-9,17.25-11.76,36.06-2.48,16.77-3,41.68,8.58,65.07,11.17,22.57,28.79,35.78,41.61,42.9a104.19,104.19,0,0,0,24.63,10,179.22,179.22,0,0,1-23-15.77c-11.83-9.51-27.89-24.9-37.3-44.26-4.15-8.56-6.87-18.84-8.1-30.57a164.82,164.82,0,0,1-.07-30.67A211.47,211.47,0,0,1,327.92,223.18Z",
    transform: "translate(-256.27 -126.66)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M381.17,323.79s3.55-35.19,55.57-59.86c25.42-17,55.57-36.79,47-75.51,3.55,1.48,24.24,25.82,28.38,45.87,1.48,19.75,8.87,75.61-57.93,98.07C469,318.17,493.78,294,492,261.91,488.46,268.52,451.52,332.36,381.17,323.79Z",
    transform: "translate(-256.27 -126.66)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M380.05,324.27S404.34,298,442,282.54c18.56-11,57.11-26.57,52.51-54.2,2.45,1.18,15.05,21.93,17.22,36.22.3,14-8.4,53.36-56.36,66.7,11-9.45,25.73-25.36,25.68-48.07C478.26,287.72,429.34,333,380.05,324.27Z",
    transform: "translate(-256.27 -126.66)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.76,221.25l3.23-6.78,3.62,2.22-3.06,6.68S352.71,222.79,351.76,221.25Z",
    transform: "translate(-256.27 -126.66)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.62,223.5l-.09,0c-.12,0-2.9-.61-3.87-2.17l0-.05,3.32-6.95,3.8,2.34Zm-3.74-2.26c.86,1.3,3.14,1.9,3.61,2l3-6.52-3.43-2.1Z",
    transform: "translate(-256.27 -126.66)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M373,192.51l7.52-4.82s5.39,1.91,5.75,3.81a30.43,30.43,0,0,1,0,5.9l-14.72,8.12Z",
    transform: "translate(-256.27 -126.66)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.46,205.72l1.47-13.27,7.62-4.88.05,0c.22.08,5.45,1.95,5.82,3.89a30.22,30.22,0,0,1,0,5.93v.06l-.05,0Zm1.68-13.14-1.41,12.74,14.47-8a28.93,28.93,0,0,0,0-5.81c-.33-1.72-5.08-3.51-5.62-3.7Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "121.78 86.07 128.8 82.23 128.8 94.61 121.78 86.07"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M385.18,221.58l-7.3-8.88,7.31-4Zm-7-8.81L385,221V209.08Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "114.03 105.25 116.21 105.19 114.03 101.25 114.03 105.25"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370.2,232v-4.53l2.46,4.46Zm.22-3.68v3.46l1.88-.06Z",
    transform: "translate(-256.27 -126.66)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.92,241.74l2-2.13s5,7,5.44,9.42S376.36,242.31,374.92,241.74Z",
    transform: "translate(-256.27 -126.66)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M382.28,249.54c-.44,0-1.49-1.19-3.62-3.71-1.49-1.75-3.17-3.75-3.78-4l-.15-.06,2.21-2.34.07.11c.21.29,5,7.09,5.46,9.46,0,.18.07.43-.1.51Zm-7.18-7.83a26.38,26.38,0,0,1,3.73,4c1.31,1.56,3.12,3.69,3.44,3.63a.51.51,0,0,0,0-.27c-.44-2.16-4.72-8.36-5.35-9.27Z",
    transform: "translate(-256.27 -126.66)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M393.92,235.88s7.3,16.17,7.3,17,6.19.86,6.19.86l6.27-16.38S395.25,234.45,393.92,235.88Z",
    transform: "translate(-256.27 -126.66)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M407.48,253.82h-.07c-1.48,0-6.3-.14-6.3-1,0-.57-4.36-10.43-7.29-16.92l0-.07,0-.05c1.36-1.46,19.12,1.29,19.87,1.41l.14,0Zm-13.43-17.91c.89,2,7.28,16.15,7.28,16.94,0,.41,3.1.71,6,.75l6.2-16.18C408.4,236.62,395.43,234.88,394.05,235.91Z",
    transform: "translate(-256.27 -126.66)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M400.39,188.44l5.78,5.45h12S407,180,403.83,178.32C402.3,180,400.39,188.44,400.39,188.44Z",
    transform: "translate(-256.27 -126.66)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M418.44,194H406.12l-5.85-5.52,0-.06c.08-.35,1.93-8.52,3.46-10.17l.05-.07.08,0c3.18,1.7,14,15,14.42,15.59Zm-12.23-.22H418c-1.31-1.61-11.09-13.58-14.13-15.32-1.41,1.68-3.16,9.19-3.33,9.95Z",
    transform: "translate(-256.27 -126.66)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M399,204.59s13.17,19,13.81,20.77c-6.52-.81-17.94-1.37-17.94-1.37l1.44-19.29Z",
    transform: "translate(-256.27 -126.66)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M413,225.49l-.18,0c-6.43-.8-17.82-1.36-17.93-1.37h-.11l1.46-19.51,2.85-.11,0,.05c.54.77,13.19,19,13.82,20.8Zm-18-1.6c1.2.06,11.53.59,17.65,1.34-1.18-2.49-13-19.48-13.69-20.53l-2.53.1Z",
    transform: "translate(-256.27 -126.66)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M413.7,204.81l6.72,9.25,1.61-8.52S416.64,204.16,413.7,204.81Z",
    transform: "translate(-256.27 -126.66)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M420.48,214.33l-7-9.59.17,0c2.93-.64,8.15.68,8.37.74l.1,0Zm-6.59-9.44,6.47,8.89,1.54-8.16C421.16,205.45,416.58,204.38,413.89,204.89Z",
    transform: "translate(-256.27 -126.66)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M422,242.55s5.6,14.43,5.56,15.11-5.57,2.85-5.57,2.85l-7.31-3.7S420.76,242.24,422,242.55Z",
    transform: "translate(-256.27 -126.66)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M422,260.63l-7.45-3.76,0-.1s1.54-3.69,3.2-7.25c3.38-7.29,4-7.13,4.26-7.07h0l0,0c.58,1.48,5.61,14.47,5.57,15.15s-4.71,2.59-5.64,2.95Zm-7.16-3.87,7.18,3.63c2.67-1.05,5.42-2.36,5.45-2.74s-3.28-9.2-5.53-15C421.09,242.77,417.68,249.91,414.83,256.76Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "179.2 118.48 180.77 124.88 184.18 120.69 179.2 118.48"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M437,251.78,435.32,245l5.31,2.35Zm-1.35-6.44,1.46,6,3.18-3.91Z",
    transform: "translate(-256.27 -126.66)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.32 85.5 184.31 107.27 172.24 102.29 170.55 98.71 175.32 85.5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M440.79,234.13,428.43,229l-1.73-3.66,4.88-13.52Zm-12.19-5.26,11.78,4.85-8.78-21.25-4.66,12.89Z",
    transform: "translate(-256.27 -126.66)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M316,385.19h8.73v2.64h-5.58v2.8h4.75v2.64h-4.75v3.21h5.79v2.65H316Z",
    transform: "translate(-256.27 -126.66)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M327.67,392.24c0-4.62,3.06-7.3,6.58-7.3a5.88,5.88,0,0,1,4.19,1.8l-1.66,2a3.5,3.5,0,0,0-2.46-1.1c-1.91,0-3.42,1.68-3.42,4.47s1.34,4.53,3.37,4.53a3.66,3.66,0,0,0,2.73-1.3l1.66,2a5.76,5.76,0,0,1-4.5,2C330.63,399.38,327.67,396.93,327.67,392.24Z",
    transform: "translate(-256.27 -126.66)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M340,392.1c0-4.55,2.57-7.16,6.33-7.16s6.32,2.62,6.32,7.16-2.57,7.28-6.32,7.28S340,396.65,340,392.1Zm9.43,0c0-2.8-1.2-4.44-3.1-4.44s-3.1,1.64-3.1,4.44,1.19,4.56,3.1,4.56S349.4,394.89,349.4,392.1Z",
    transform: "translate(-256.27 -126.66)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M360.15,392.24c0-4.62,3.07-7.3,6.79-7.3a6,6,0,0,1,4.39,1.8l-1.66,2a3.62,3.62,0,0,0-2.63-1.1c-2.14,0-3.66,1.68-3.66,4.47s1.29,4.53,3.91,4.53a2.51,2.51,0,0,0,1.48-.41v-2.41h-2.31v-2.57h5.11v6.42a6.74,6.74,0,0,1-4.6,1.69C363.13,399.38,360.15,396.93,360.15,392.24Z",
    transform: "translate(-256.27 -126.66)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M375.08,385.19h5c3,0,5.38,1,5.38,4.34s-2.42,4.58-5.38,4.58h-1.87v5h-3.15Zm4.77,6.42c1.65,0,2.54-.71,2.54-2.08s-.89-1.84-2.54-1.84h-1.62v3.92Zm-.32,1.67,2.18-2,4.44,7.86h-3.52Z",
    transform: "translate(-256.27 -126.66)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M388.83,385.19h8.73v2.64H392v2.8h4.75v2.64H392v3.21h5.79v2.65h-8.94Z",
    transform: "translate(-256.27 -126.66)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M401.19,385.19h8.73v2.64h-5.58v2.8h4.75v2.64h-4.75v3.21h5.79v2.65h-8.94Z",
    transform: "translate(-256.27 -126.66)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M413.54,385.19h3.23l3.63,6.93,1.38,3.06h.09c-.15-1.47-.4-3.42-.4-5.07v-4.92h3v13.94h-3.23l-3.64-6.95-1.37-3.05h-.09c.15,1.54.4,3.41.4,5.05v4.95h-3Z",
    transform: "translate(-256.27 -126.66)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M433.31,385.19h4.79c3.07,0,5.54,1.1,5.54,4.48s-2.5,4.73-5.45,4.73h-1.73v4.73h-3.15ZM438,391.9c1.73,0,2.55-.77,2.55-2.23s-.93-2-2.63-2h-1.46v4.21Z",
    transform: "translate(-256.27 -126.66)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M446.7,385.19h5c3,0,5.38,1,5.38,4.34s-2.42,4.58-5.38,4.58h-1.86v5H446.7Zm4.76,6.42c1.65,0,2.54-.71,2.54-2.08s-.89-1.84-2.54-1.84h-1.61v3.92Zm-.32,1.67,2.18-2,4.44,7.86h-3.52Z",
    transform: "translate(-256.27 -126.66)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M459.78,392.1c0-4.55,2.57-7.16,6.33-7.16s6.33,2.62,6.33,7.16-2.57,7.28-6.33,7.28S459.78,396.65,459.78,392.1Zm9.43,0c0-2.8-1.2-4.44-3.1-4.44s-3.1,1.64-3.1,4.44,1.2,4.56,3.1,4.56S469.21,394.89,469.21,392.1Z",
    transform: "translate(-256.27 -126.66)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M473.25,396.86l2.14-1.59a2.26,2.26,0,0,0,1.94,1.39c1.13,0,1.74-.57,1.74-2.43v-9h3.14v9.3c0,2.68-1.39,4.89-4.46,4.89A4.71,4.71,0,0,1,473.25,396.86Z",
    transform: "translate(-256.27 -126.66)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M486.07,385.19h8.73v2.64h-5.58v2.8H494v2.64h-4.75v3.21H495v2.65h-8.95Z",
    transform: "translate(-256.27 -126.66)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M497.77,392.24c0-4.62,3.06-7.3,6.58-7.3a5.88,5.88,0,0,1,4.19,1.8l-1.66,2a3.5,3.5,0,0,0-2.46-1.1c-1.91,0-3.42,1.68-3.42,4.47s1.33,4.53,3.37,4.53a3.66,3.66,0,0,0,2.72-1.3l1.66,2a5.73,5.73,0,0,1-4.5,2C500.72,399.38,497.77,396.93,497.77,392.24Z",
    transform: "translate(-256.27 -126.66)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M514,387.83h-3.83v-2.64H521v2.64h-3.84v11.3H514Z",
    transform: "translate(-256.27 -126.66)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M522.35,397.37l1.81-2.16a5.54,5.54,0,0,0,3.42,1.45c1.31,0,2-.52,2-1.34s-.79-1.16-2-1.66l-1.81-.77a4.06,4.06,0,0,1-2.81-3.8c0-2.31,2.06-4.15,5-4.15a6.45,6.45,0,0,1,4.48,1.82l-1.59,2a4.5,4.5,0,0,0-2.89-1.09c-1.09,0-1.78.45-1.78,1.24s.91,1.17,2.13,1.65l1.77.72a3.84,3.84,0,0,1,2.77,3.79c0,2.32-1.93,4.32-5.25,4.32A7.66,7.66,0,0,1,522.35,397.37Z",
    transform: "translate(-256.27 -126.66)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M363.82,413.36l1.1-1.32a3.33,3.33,0,0,0,2.08.89c.8,0,1.19-.32,1.19-.82s-.48-.7-1.22-1l-1.1-.47a2.46,2.46,0,0,1-1.71-2.31,2.73,2.73,0,0,1,3-2.52,3.9,3.9,0,0,1,2.73,1.11l-1,1.21a2.74,2.74,0,0,0-1.76-.67c-.66,0-1.08.28-1.08.76s.56.71,1.3,1l1.08.44a2.35,2.35,0,0,1,1.68,2.31c0,1.4-1.17,2.62-3.19,2.62A4.63,4.63,0,0,1,363.82,413.36Z",
    transform: "translate(-256.27 -126.66)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M371.58,410.15c0-2.77,1.57-4.35,3.85-4.35s3.85,1.6,3.85,4.35-1.56,4.43-3.85,4.43S371.58,412.92,371.58,410.15Zm5.74,0c0-1.7-.73-2.7-1.89-2.7s-1.88,1-1.88,2.7.72,2.78,1.88,2.78S377.32,411.85,377.32,410.15Z",
    transform: "translate(-256.27 -126.66)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M381.26,406h1.92v6.87h3.34v1.61h-5.26Z",
    transform: "translate(-256.27 -126.66)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M389.89,406h2.29l2.66,8.48h-2l-1.11-4.29c-.23-.85-.46-1.85-.68-2.74H391c-.2.9-.43,1.89-.66,2.74l-1.12,4.29h-1.95Zm-.91,5h4.08v1.49H389Z",
    transform: "translate(-256.27 -126.66)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M396.05,406h3.05c1.79,0,3.27.63,3.27,2.64s-1.48,2.79-3.27,2.79H398v3.05h-1.91Zm2.89,3.91c1,0,1.55-.43,1.55-1.27s-.54-1.12-1.55-1.12h-1v2.39Zm-.19,1,1.32-1.22,2.71,4.78h-2.15Z",
    transform: "translate(-256.27 -126.66)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M406.85,413.36,408,412a3.33,3.33,0,0,0,2.08.89c.8,0,1.19-.32,1.19-.82s-.48-.7-1.22-1l-1.1-.47a2.46,2.46,0,0,1-1.71-2.31,2.73,2.73,0,0,1,3-2.52,3.9,3.9,0,0,1,2.73,1.11l-1,1.21a2.74,2.74,0,0,0-1.76-.67c-.66,0-1.08.28-1.08.76s.56.71,1.3,1l1.08.44a2.35,2.35,0,0,1,1.68,2.31c0,1.4-1.18,2.62-3.19,2.62A4.63,4.63,0,0,1,406.85,413.36Z",
    transform: "translate(-256.27 -126.66)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M414.61,410.15c0-2.77,1.56-4.35,3.85-4.35s3.85,1.6,3.85,4.35-1.56,4.43-3.85,4.43S414.61,412.92,414.61,410.15Zm5.74,0c0-1.7-.73-2.7-1.89-2.7s-1.89,1-1.89,2.7.73,2.78,1.89,2.78S420.35,411.85,420.35,410.15Z",
    transform: "translate(-256.27 -126.66)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M424.29,406h1.92v6.87h3.34v1.61h-5.26Z",
    transform: "translate(-256.27 -126.66)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M430.89,410.5V406h1.92v4.75c0,1.66.52,2.23,1.47,2.23s1.5-.57,1.5-2.23V406h1.85v4.55c0,2.84-1.16,4.08-3.35,4.08S430.89,413.34,430.89,410.5Z",
    transform: "translate(-256.27 -126.66)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M441.63,407.56H439.3V406h6.58v1.61h-2.33v6.87h-1.92Z",
    transform: "translate(-256.27 -126.66)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M447.59,406h1.92v8.48h-1.92Z",
    transform: "translate(-256.27 -126.66)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M451.49,410.15c0-2.77,1.57-4.35,3.85-4.35s3.85,1.6,3.85,4.35-1.56,4.43-3.85,4.43S451.49,412.92,451.49,410.15Zm5.74,0c0-1.7-.73-2.7-1.89-2.7s-1.88,1-1.88,2.7.72,2.78,1.88,2.78S457.23,411.85,457.23,410.15Z",
    transform: "translate(-256.27 -126.66)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M461.17,406h2l2.21,4.22.84,1.86h.05c-.09-.9-.25-2.08-.25-3.08v-3h1.83v8.48h-2l-2.21-4.23-.84-1.85h-.06a30.27,30.27,0,0,1,.25,3.07v3h-1.83Z",
    transform: "translate(-256.27 -126.66)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M469.66,413.36l1.1-1.32a3.38,3.38,0,0,0,2.08.89c.8,0,1.2-.32,1.2-.82s-.49-.7-1.23-1l-1.1-.47a2.46,2.46,0,0,1-1.71-2.31,2.74,2.74,0,0,1,3-2.52,3.9,3.9,0,0,1,2.73,1.11l-1,1.21a2.76,2.76,0,0,0-1.76-.67c-.66,0-1.08.28-1.08.76s.55.71,1.29,1l1.08.44A2.34,2.34,0,0,1,476,412c0,1.4-1.17,2.62-3.19,2.62A4.67,4.67,0,0,1,469.66,413.36Z",
    transform: "translate(-256.27 -126.66)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcologo);
export default __webpack_public_path__ + "static/media/ecologo.64166743b109930f24603f0783ea53e6.svg";
export { ForwardRef as ReactComponent };